import { Controller } from "react-hook-form";
import { Inputs, Label } from "components";
import { FormDatePickerNewStyled } from "./styled";

const FormDatePickerNew = ({
  control,
  name,
  label,
  required = false,
  subLabel,
  errors,
  disabled,
  theme_standard,
  placeholder,
  format,
  buddhistYear,
  showMonthYearPicker,
  minDate,
  maxDate,
  onChangeCustom,
}) => (
  <FormDatePickerNewStyled>
    <div className="box_input_item">
      {label && (
        <Label.LabelForm label={label} required={required} subLabel={subLabel} />
      )}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Inputs.InputDatePickerNew
            theme_standard={theme_standard}
            value={field.value}
            onChange={(e) => {
              field.onChange(e);
              onChangeCustom && onChangeCustom(e);
            }}
            disabled={disabled}
            placeholder={placeholder}
            format={format}
            buddhistYear={buddhistYear}
            showMonthYearPicker={showMonthYearPicker}
            minDate={minDate}
            maxDate={maxDate}
          />
        )}
      />
      {errors && <span className="error_message">{errors}</span>}
    </div>
  </FormDatePickerNewStyled>
);

export default FormDatePickerNew;
